import { Flex } from '@sendoutcards/quantum-design-ui'
import React, { useEffect, useMemo, useState } from 'react'
import { BentoContainer } from './BentoGrid/BentoContainer'

type SectionBentoContainerProps = {
  isMobile?: boolean
  imageUrl: string
}

export const SectionBentoContainer: React.FC<SectionBentoContainerProps> = ({
  isMobile,
  imageUrl,
}) => {
  const useImageSize = (src?: string) => {
    const [size, setSize] = useState<{ w: number; h: number } | null>(null)

    useEffect(() => {
      if (!src) return

      const img = new Image()
      let mutableCancel = false

      const onLoad = () => {
        if (!mutableCancel) {
          setSize({ w: img.naturalWidth, h: img.naturalHeight })
        }
      }

      const onError = () => {
        if (!mutableCancel) {
          setSize(null)
        }
      }

      img.addEventListener('load', onLoad)
      img.addEventListener('error', onError)
      img.setAttribute('src', src)

      return () => {
        mutableCancel = true
        img.removeEventListener('load', onLoad)
        img.removeEventListener('error', onError)
      }
    }, [src])

    return size
  }

  const fallback =
    'https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/editor-animation.gif'
  const src = imageUrl || fallback

  const size = useImageSize(src)
  const lower = src.toLowerCase()
  const isPNG = lower.endsWith('.png')
  const isGIF = lower.endsWith('.gif')
  const isCutout = isPNG && /no[-_ ]?background|cutout|transparent/.test(lower)

  const backgroundSize = useMemo<'contain' | 'cover'>(() => {
    if (isMobile) return 'contain'
    if (isGIF && !isCutout) return 'cover'
    return 'contain'
  }, [isMobile, isGIF, isCutout])

  const backgroundPosition =
    backgroundSize === 'cover' && !isMobile ? 'right center' : 'center'

  const aspect = size
    ? `${size.w} / ${size.h}`
    : isGIF
    ? isMobile
      ? '16 / 9'
      : '21 / 9'
    : isMobile
    ? '1 / 1'
    : '4 / 3'

  return (
    <Flex
      width="100%"
      height="inherit"
      maxHeight="600px"
      maxWidth="600px"
      justifyContent="center"
      alignItems="center"
      borderRadius="default"
    >
      <BentoContainer
        isActive={false}
        onClick={() => {}}
        blobs={{
          option: 1,
          width: '95%',
          height: 'auto',
          glassBlur: 65,
        }}
        width="100%"
        height="auto"
      >
        <Flex
          width="100%"
          height="auto"
          minHeight={isMobile ? '200px' : '300px'}
          maxHeight="600px"
          style={{ aspectRatio: aspect }}
          alignItems="center"
          justifyContent="center"
          backgroundSize={backgroundSize}
          backgroundPosition={backgroundPosition}
          backgroundRepeat="no-repeat"
          backgroundImage={src}
          borderRadius="default"
        />
      </BentoContainer>
    </Flex>
  )
}
